/* Layouts */
const Layout = () => import("@/layout/index.vue");
/* Layouts */

/* Authenticated Component */
const Settings = () => import("@/views/settings/index.vue");
const EmailSettings = () => import("@/views/settings/email.vue");
/* Authenticated Component */

export default [
    {
        path: "/settings",
        component: Layout,
        meta: { title: "Settings", icon: "tree", roles: ["super-admin"] },
        children: [
            {
                name: "default",
                path: "/setting/default",
                component: Settings,
                meta: { title: "Default" },
            },
            {
                name: "email",
                path: "email",
                component: EmailSettings,
                meta: { title: "Email" },
            },
        ],
    },
];
